/**
 * @constant
 * @type {object}
 * @param {string} PRO
 * @param {string} BUSINESS
 * @param {string} FIVERR_CHOICE
 * @param {string} LOYALTY
 * */
export const TYPE = {
    PRO: 'PRO',
    BUSINESS: 'BUSINESS',
    FIVERR_CHOICE: 'FIVERR_CHOICE',
    LOYALTY: 'LOYALTY'
};

/**
 * @constant {string}
 * @desc The prefix of the copy key
 * **/
export const COPY_ROOT = 'gig_page_perseus.expert_card.badge';
